<template>
  <div>
  </div>
</template>

<script>
import { O3DG2 } from '../../../Reusable/O3DG2'
import { BoxBufferGeometry, Mesh } from 'three'
let boxGeo = new BoxBufferGeometry(1, 1, 1, 2, 2, 2)
export default {
  mixins: [O3DG2],
  props: {
    mat: {
      default: 'grayMat'
    }
  },
  methods: {
    setup () {
      let mesh = new Mesh(boxGeo, this.ctx[this.mat])
      this.$watch('mat', () => {
        mesh.material = this.ctx[this.mat]
      })
      this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>